import React from "react";

export default function BirthChildFrame4({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1500 1500"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>{".cls-4bir1{fill:#9de9ed}.cls-4bir2{fill:#9cacef}"}</style>
        </defs>
        <path
          d="M498.57 710.5v207.8c0 145.48 117.93 263.41 263.41 263.41h131.04c145.48 0 263.41-117.93 263.41-263.41V710.5H498.57Zm512.65 351.45c0 36.04-29.22 65.26-65.26 65.26H709.05c-36.05 0-65.27-29.22-65.27-65.26V825.04c0-36.04 29.22-65.26 65.27-65.26h236.91c36.04 0 65.26 29.22 65.26 65.26v236.91Z"
          className="cls-4bir2"
        />
        <circle cx={674.78} cy={1271.77} r={71.79} className="cls-4bir1" />
        <circle cx={981.09} cy={1271.77} r={71.79} className="cls-4bir1" />
        <circle cx={403.29} cy={548.97} r={59.72} className="cls-4bir1" />
        <path
          d="M584.95 677.35 561 675.77c.75-11.44.19-40.92-21.23-67.67-22.16-27.67-51.9-34.26-63.65-35.81l3.14-23.79c14.63 1.93 51.64 10.14 79.24 44.6 26.69 33.32 27.39 70.02 26.45 84.25Z"
          className="cls-4bir2"
        />
        <path
          d="M854.91 373.74c166.41 0 301.52 135.11 301.52 301.52v11.75H854.91V373.74Z"
          className="cls-4bir1"
        />
        <path
          d="M682.1 442.44c-6.05-12.43-2.65-33.56 12.84-41.27 9.79-4.87 22.1-3.24 31.78 3.74-4.88-11.03-3.23-23.59 4.21-31.72 10.51-11.49 28.5-9.66 38.48-2.98.97.65 3.81 2.64 6.51 6.24 8.34 11.11 6.37 25.49 5.17 35.23-1.71 13.91-3.52 32.07-5.04 56.66a457.368 457.368 0 0 1-32.05-4.28c-15.07-2.56-11.48-2.74-24.11-4.8-17.34-2.83-24.81-2.61-31.96-9.17-3.71-3.4-5.47-6.92-5.83-7.66ZM813.71 183.91c11.23-20.32 43.54-36.08 69.1-22.24 16.15 8.74 25.8 27.23 25.57 47.26 10.44-17.36 29.28-27.23 47.63-24.87 25.94 3.34 40.81 29.81 41.29 49.98.05 1.97.05 7.78-2.29 14.97-7.2 22.19-28.85 33.37-43.4 41.15-20.76 11.1-47.45 26.15-82.7 47.83a767.443 767.443 0 0 1-25.1-48.16c-11.05-23.17-7.33-18.42-16.7-37.75-12.87-26.55-20.39-36.6-18.29-52.75 1.09-8.39 4.22-14.21 4.89-15.41ZM695.07 279.42c-2.45-8.6 2.11-21.68 12.85-24.83 6.79-1.99 14.44.44 19.82 5.98-1.86-7.58.61-15.39 6.27-19.73 8-6.13 19.25-2.93 24.85 2.46.55.52 2.13 2.11 3.44 4.71 4.05 8.02 1.17 16.95-.7 23.03-2.66 8.67-5.87 20.03-9.62 35.52a295.95 295.95 0 0 1-19.93-6.35c-9.31-3.34-7-3.05-14.81-5.79-10.73-3.76-15.51-4.47-19.32-9.46-1.98-2.59-2.7-5.03-2.85-5.54Z"
          className="cls-4bir2"
        />
        <circle cx={674.78} cy={1271.77} r={27.19} className="cls-4bir2" />
        <circle cx={981.09} cy={1271.77} r={27.19} className="cls-4bir2" />
        {children}
      </g>
    </svg>
  );
}
